import { render, staticRenderFns } from "./sTableComment.vue?vue&type=template&id=31eb7638&scoped=true&"
import script from "./sTableComment.vue?vue&type=script&lang=js&"
export * from "./sTableComment.vue?vue&type=script&lang=js&"
import style0 from "./sTableComment.vue?vue&type=style&index=0&id=31eb7638&scoped=true&lang=css&"
import style1 from "./sTableComment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eb7638",
  null
  
)

export default component.exports